const Style = {
    shell: 'flex h-full flex-col gap-4 p-5',
    description: 'text-sm text-text-secondary',
};

export default Style;
